export const getLockedLocale = (key) => {
  if (key === 'china') {
    return 'zh'
  }
}
